// src/component/groupActivity2026Defaults.js
//
// 「2026 グループ活動 参加可否ダイアログ／マイページ動線」の Firestore 設定
// が未設定の場合に使う既定値、および設定ドキュメント名を集約。

export const GROUP_ACTIVITY_2026_CONFIG_DOC = "groupActivity2026Dialog";

// 公開範囲
//  - "admin" : 管理者のみに見せる（テスト段階のデフォルト）
//  - "all"   : 全ユーザーに見せる
// ダイアログ／マイページ動線ツールチップ／マイページのカード が連動して切り替わる。
export const GA2026_AUDIENCE = { ADMIN: "admin", ALL: "all" };

export const GROUP_ACTIVITY_2026_DEFAULTS = {
  audience: GA2026_AUDIENCE.ADMIN,

  // ダイアログ本体の文言
  chipLabel: "⚡️4期 グループ活動 2026⚡️（仮）",
  heading: "今年もグループ活動が始まります。",
  body:
    "※ こちらは仮の文言です。正式な案内文は後ほど差し替えます。\n" +
    "\n" +
    "2026年のグループ活動に参加されますか？",

  // 左レール／ボトムナビのマイページ動線に出す常時ツールチップ
  tooltipEnabled: false,
  tooltipText: "2026グループ参加の意思表示はこちら",

  // 回答期日（YYYY-MM-DD の文字列。未設定なら空文字）
  deadline: "",
};
